<template>
  <div class="sm-scan-preview">
    <div
      v-if="status == 'loading'"
      class="sm-scan-preview__spinner"
    >
      <lottie
        :options="options"
        :height="30"
        :width="30"
      />
    </div>
    <include-svg 
      v-else-if="status == 'loaded'"
      :name="'icon-download'"
    />
    <div
      v-else-if="status == 'error'"
      class="sm-scan-preview__error"
    >
      <include-svg :name="'icon-document-error'" />
    </div>

    <hint-block v-if="showHint">
      <template slot="hintContent">{{hintText}}</template>
    </hint-block>
  </div>
</template>

<script>
import Lottie from 'vue-lottie';
import AnimationData from '@/assets/json/spinner.json';
import Hint from '@/components/Hint.vue';

export default {
  name: 'scan-preview',
  components: {
    'lottie': Lottie,
    'hint-block': Hint,
  },
  props: {
    src: {
      type: String,
      required: true
    },
    showHint: {
      type: Boolean,
      defaul: false
    }
  },
  data() {
    return {
      status: 'loading', // values: loading, loaded, error
      options: {
        animationData: AnimationData
      }
    }
  },
  computed: {
    hintText() {
      if (this.status == 'loading')
        return 'Loading...';

      if (this.status == 'error')
        return 'Scan error';

      return 'Download scan';
    }
  },
  created() {
    fetch(this.src)
      .then(res => {
        return res.blob();
      })
      .then(blob => {
        if (blob && blob.type && blob.type != 'text/html') {
          this.status = 'loaded';
        } else {
          this.status = 'error';
        }
      })
      .catch(e => {
        this.status = 'error';
      });
  }
}
</script>

<style lang="scss">
  .sm-scan-preview {
    position: relative;
  }
</style>